export default {
  title: 'مدیریت روش ارسال ها',
  search:'جستجو ...',
  id: 'شناسه',
  nameFa : 'عنوان فارسی',
  nameEn : 'عنوان لاتین',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  btnCreate:'اضافه کردن',
  shippingCost:'هزینه ی ارسال',
  placeholderShippingCost:'هزینه ی ارسال',
  ErrorRetrievingInformation:'خطا در دریافت اطلاعات',
  next: 'بعدی',
  previous: 'قبلی',
  deleteConfirm:'آیا از حذف این روش ارسال مطمئن هستید؟'




}
